import * as Yup from "yup";

const SignupSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Required"),
  password: Yup.string()
    .min(6, "Too Short!")
    .max(15, "Too Long!")
    .required("Required"),
});

const RegisterSchema = Yup.object().shape({
  first_name: Yup.string().required('First name is required'),
  last_name: Yup.string().required('Last name is required'),
  email: Yup.string().email("Invalid email").required("Email is required"),
  password: Yup.string()
    .min(6, "Password is too Short!")
    .required("Password Required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password')], 'Password must match')
});

const LoginSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required"),
  password: Yup.string()
    .required("Required"),
});

const ForgotPasswordSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required")
});

const ResetPasswordSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required"),
  code: Yup.number().required("Code is required"),
  newPassword: Yup.string().required('New password is required'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('newPassword')], 'Password must match')
});


const updateProfileSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Password is required"),
  username: Yup.string()
    .min(2, "Too Short!")
    .max(20, "Too Long!")
    .required("Required"),
});

const UserProfileUpdateSchema = Yup.object().shape({
  //email_address: Yup.string().email("Invalid email").required("Email is required"),
  first_name: Yup.string().required('First name is required'),
  last_name: Yup.string().required('Last name is required'),
  user_bio: Yup.string().nullable(),
});

const ListingProfileUpdateSchema = Yup.object().shape({
  first_name: Yup.string().required('First name is required'),
  last_name: Yup.string().required('Last name is required'),
  user_bio: Yup.string().nullable(),
  streetAddress: Yup.string().optional(),
  city: Yup.string().optional(),
  state: Yup.string().optional(),
  zip: Yup.string().matches(/^\d{5}$/, 'Invalid ZIP code').optional(),
});

const DeleteAccountSchema = Yup.object().shape({
  emailAddress: Yup.string().email("Invalid email").required("Email is required"),
  confirmEmail: Yup.string().oneOf([Yup.ref('emailAddress')], 'Email address must match')
});

const NewDeleteAccountSchema = Yup.object().shape({
  password: Yup.string().required("Password is required")
});

const ChangePasswordSchema = Yup.object().shape({
  oldPassword: Yup.string().required("Password is required"),
  newPassword: Yup.string().required('New Password is required'),
  confirmPassword: Yup.string().oneOf([Yup.ref('newPassword')], 'Password must match')
});

const SwitchUserRoleSchema = Yup.object().shape({
  roleId: Yup.number().required("Select a role")
});

export { 
  SignupSchema, 
  LoginSchema, 
  updateProfileSchema, 
  RegisterSchema, 
  ForgotPasswordSchema, 
  ResetPasswordSchema, 
  DeleteAccountSchema,
  UserProfileUpdateSchema,
  ChangePasswordSchema,
  SwitchUserRoleSchema,
  NewDeleteAccountSchema,
  ListingProfileUpdateSchema
};
